import React from 'react';
import { cn } from '../../utils/cn';

export function Avatar({ className, ...props }) {
    return (
        <div className={cn('relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full', className)} {...props} />
    );
}

export function AvatarImage({ className, src, alt, ...props }) {
    return <img src={src} alt={alt} className={cn('aspect-square h-full w-full object-cover', className)} {...props} />;
}

export function AvatarFallback({ className, ...props }) {
    return (
        <div
            className={cn(
                'bg-slate-100 flex h-full w-full items-center justify-center rounded-full text-slate-600 text-sm font-medium',
                className
            )}
            {...props}
        />
    );
}
